/** @jsx jsx */
import { jsx } from '@emotion/react';
import { PureComponent } from 'react';
import { Button, INonIdealStateProps, NonIdealState } from '@blueprintjs/core';

interface Props extends INonIdealStateProps {
	retryButtonText?: boolean | string;
	onReset?: () => unknown;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends PureComponent<Props, State> {
	state = {
		hasError: false,
	};

	componentDidCatch(error, info) {
		this.setState({
			hasError: true,
		});

		console.error(error, info);
	}

	resetError = () => {
		this.props?.onReset?.()
		this.setState({hasError: false});
	};

	render() {
		const {
			title = 'Ouch!',
			description = "Something didn't go as planned. Reload the page and try again. If that doesn't work contact your support personnel.",
			children,
			retryButtonText = false,
			...otherProps
		} = this.props;
		const {hasError} = this.state;
		if (hasError) {
			return (
				<NonIdealState
					icon={'error'}
					action={
						!!retryButtonText && (
							<Button cy-test="fetch-again-button" text={retryButtonText} onClick={this.resetError} />
						)
					}
					// title={title}
					// description={description}
					{...otherProps}
				/>
			);
		} else {
			return children;
		}
	}
}
